import React from 'react';
import { RouteComponentProps, withRouter } from "react-router-dom";
import styled from 'styled-components';
import { Image } from 'UI-Dash-Commons-UI';

import BottomLeftMenuComponent from "../components/BottomLeftMenuComponent";
import LeftSideMenuSectionComponent from '../components/LeftSideMenuSectionComponent';

import { DOCS_BOTTOM_MENU, DOCS_LEFT_MENU } from "../constants/constants";
import DocsMenuSection from "../types/DocsMenuSection";
import DocsSectionUtils from "../utils/DocsSectionUtils";

const logo = require( '../images/menu/menu_full_logo.svg' );

type LeftSideMenuContainerState =
    {
        activeSectionUrl: string,
        openSectionUrl: string
    };

class LeftSideMenuContainer extends React.Component<RouteComponentProps, LeftSideMenuContainerState>
{
    private static leftMenu: DocsMenuSection = DOCS_LEFT_MENU;
    private static bottomMenu: Array<DocsMenuSection> = DOCS_BOTTOM_MENU;

    private handleOnclick = ( newUrl: string ) =>
    {
        const newOpenSectionUrl = DocsSectionUtils.getOpenSection( newUrl, LeftSideMenuContainer.leftMenu );

        this.setState(
            {
                activeSectionUrl: newUrl,
                openSectionUrl: newOpenSectionUrl
            }
        );
    };

    private handleOpenSection = ( newSectionUrl: string ) =>
    {
        this.setState( { openSectionUrl: newSectionUrl } );
    };

    constructor( props )
    {
        super( props );

        const activeSectionUrl = DocsSectionUtils.getActiveSection( this.props.location.pathname, LeftSideMenuContainer.leftMenu );
        const openSectionUrl = DocsSectionUtils.getOpenSection( this.props.location.pathname, LeftSideMenuContainer.leftMenu );

        this.state =
            {
                activeSectionUrl: activeSectionUrl,
                openSectionUrl: openSectionUrl
            };

    }

    static getDerivedStateFromProps( nextProps, prevState )
    {
        const newActiveSectionUrl = DocsSectionUtils.getActiveSection( nextProps.location.pathname, LeftSideMenuContainer.leftMenu );
        const newOpenSectionUrl = DocsSectionUtils.getOpenSection( nextProps.location.pathname, LeftSideMenuContainer.leftMenu );


        // strictly used for when navigation is perform outside of the left nav
        if ( newActiveSectionUrl !== prevState.activeSectionUrl )
        {
            return {
                activeSectionUrl: newActiveSectionUrl,
                openSectionUrl: newOpenSectionUrl
            }
        }

        return null;
    }

    render()
    {
        return (
            <LeftSideMenuContainerWrapper>
                <Logo
                    src={logo}
                    alt={'AppLovin'}
                    height={'28px'}
                />

                <LeftSideMenuSectionComponent
                    activeSectionUrl={this.state.activeSectionUrl}
                    handleOnClick={this.handleOnclick}
                    handleOpenSection={this.handleOpenSection}
                    key={LeftSideMenuContainer.leftMenu.url}
                    level={0}
                    menuSection={LeftSideMenuContainer.leftMenu}
                    openSectionUrl={this.state.openSectionUrl}>
                </LeftSideMenuSectionComponent>

                <BottomLeftMenuComponent
                    menu={LeftSideMenuContainer.bottomMenu}
                />
            </LeftSideMenuContainerWrapper>
        );
    }
}

const LeftSideMenuContainerWithRouter = withRouter( LeftSideMenuContainer );

const LeftSideMenuContainerWrapper = styled.nav`
  width: 260px;

  height: calc(100% - 116px);

  display: flex;
  flex-direction: column;
  z-index: 10;

  transition-delay: 0.15s;
  transition: width 0.33s linear;

  position: fixed;

  overflow: hidden;

  box-shadow: inset -8px 0 2px -6px #DDD;
  background-color: #F1F4F5;
`;

const Logo = styled( Image )`
  padding: 5px 0 5px 15px;
  background-color: #232323;  
`;

export default LeftSideMenuContainerWithRouter;
